import type { VueOidcSettings } from 'vue3-oidc';
import { createOidc, useOidcStore } from 'vue3-oidc';
import { unref } from 'vue';
import { WebStorageStateStore } from 'oidc-client-ts';
import { useStore } from './store';
import { AuthActionTypes } from './store/auth/action-types';
import Smartlook from 'smartlook-client';
import { stop, start } from './signalr';

const { state, actions } = useOidcStore();

const oidcSettings: VueOidcSettings = {
  authority: import.meta.env.VITE_APP_AUTHORITY as string,
  scope: 'openid api email roles controletecnologicoapi offline_access',
  client_id: 'controletecnologico',
  redirect_uri: window.location.origin + '/auth/oidc-callback',
  response_type: 'code',
  automaticSilentRenew: false,
  post_logout_redirect_uri: window.location.origin + '/lockscreen',
  userStore: new WebStorageStateStore({
    prefix: 'vue3-oidc-controletecnologico-',
    store: window.localStorage
  }),

  onSigninRedirectCallback(user) {
    console.log(user);
    location.href = unref(state).redirect_uri || '/';
  }
};

function runAuth() {
  createOidc({
    oidcSettings: oidcSettings, //your oidc settings
    auth: false, //if auth is true,will auto authenticate
    //your oidc events
    events: {
      addSilentRenewError: () => {
        console.log('deu erro');
      },
      addUserLoaded: (user) => {
        actions.value.setUser(user);
        start();
        if (import.meta.env.MODE === 'production')
          Smartlook.identify(user.profile.sub, {
            name: user.profile.name!,
            email: user.profile.email!
            // other custom properties
          });

        useStore().dispatch(AuthActionTypes.ACTION_LOGIN);
      },

      addUserSignedOut: () => {
        console.log('addUserSignedOut');
        stop();
      },

      addUserSignedIn: () => {}
    }
  });
}

runAuth();
